import { WandSparkles } from 'lucide-react';

import type { IdeaDetail } from '@/api/types';
import { RowMenu } from '@/ui/RowMenu';
import { isPending } from '@/ui/ResearchStatusPill';
import { shownResearch, type IdeaDetailUi } from './useIdeaDetail';
import { ExportPdfButton } from './ExportPdfButton';
import { ideaMenuItems } from './ideaMenu';

function RefineButton({ running, onRefine }: { running: boolean; onRefine: () => void }) {
  return (
    <button
      type="button"
      className="btn btn-secondary btn-sm"
      disabled={running}
      title={running ? 'Research is already queued or running' : undefined}
      onClick={onRefine}
    >
      <WandSparkles aria-hidden="true" /> Refine
    </button>
  );
}

/** The facts card's actions: export the research on screen, refine (research runs again, optionally with a refinement), and the More actions menu. */
export function IdeaActions({ idea, ui }: { idea: IdeaDetail; ui: IdeaDetailUi }) {
  const shown = shownResearch(idea, ui);
  return (
    <>
      {shown && ui.canExport && <ExportPdfButton ideaId={idea.id} researchId={shown.id} current={!ui.viewing} />}
      {idea.permissions.can_rerun && (
        <RefineButton running={isPending(idea.research_status)} onRefine={() => ui.setConfirm({ kind: 'rerun' })} />
      )}
      <RowMenu label="More actions for this idea" items={ideaMenuItems(idea, ui)} />
    </>
  );
}
